import { UseFormRegister } from 'react-hook-form';
import { RawFormFillerData } from 'shared-utils/types/formFiller';
import { StyledTextInput } from '../styles';
import { FieldState, getTabIndex } from '../../../lib/formFiller';
import { WithOptionalTooltip } from './WithOptionalTooltip';

/**
 * Text input field component for PDF forms
 */
export function TextFieldInput({
  fieldState,
  value,
  register,
}: {
  fieldState: FieldState;
  value: any;
  register: UseFormRegister<RawFormFillerData>;
}) {
  return (
    <WithOptionalTooltip fieldState={fieldState}>
      <StyledTextInput
        $isUnassigned={!fieldState.isAssigned}
        $isEmpty={fieldState.isEmpty}
        $isRequired={fieldState.isRequired}
        $isReadOnly={fieldState.isReadOnly}
        {...register(fieldState.id)}
        type="text"
        $fieldType="text"
        readOnly={fieldState.isReadOnly}
        tabIndex={getTabIndex(fieldState)}
        autoComplete="off"
        value={value}
      />
    </WithOptionalTooltip>
  );
}
